import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
import login from "../components/login/login.vue"; //登录
Vue.use(VueRouter);

const router = new VueRouter({
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "login",
      meta: {
        title: "管理系统",
        /* keepAlive:true*/
      },
      component: () => import("../components/login/login.vue"),
    },
    {
      path: "/",
      redirect: {
        name: "login",
      },
    },
    {
      path: "/homePage",
      name: "homePage",
      component: () => import("../components/homePage/homePage.vue"),
      redirect: {
        name: "statistics",
      },
      children: [
        {
          // 可视菜单页面
          path: "/",
          name: "statistics",
          meta: {
            title: "增值业务管理系统",
          },
          component: () => import("../view/homePageManagement/index.vue"),
        },
        {
          path: "objUserInfoList", //
          name: "objUserInfoList",
          meta: {
            title: "用户管理",
            /*keepAlive:true*/
          },
          component: () =>
            import("../components/systemManagement/userSettings.vue"),
        },
        // 用户管理 产品服务
        {
          path: "objUserProductList",
          name: "objUserProductList",
          meta: {
            title: "产品服务",
            /*keepAlive:true*/
          },
          component: () =>
            import("../components/systemManagement/productSettings.vue"),
        },
        {
          path: "sysObjRoleList",
          name: "sysObjRoleList",
          meta: {
            title: "角色管理",
            /*keepAlive:true*/
          },
          component: () =>
            import("../components/systemManagement/roleSettings.vue"),
        },
        //机构管理 机构列表
        {
          path: "rmOfficeInfoList",
          name: "rmOfficeInfoList",
          component: () => import("../view/rmOfficeInfo/index.vue"),
        },
        //机构管理 机构列表  创建机构
        {
          path: "createOfficeInfo",
          name: "createOfficeInfo",
          component: () => import("../view/rmOfficeInfo/create.vue"),
        },
        //HR管理 HR列表
        {
          path: "hrInfoList",
          name: "hrInfoList",
          component: () => import("../view/hrInfo/index.vue"),
        },
        // HR管理 HR列表  创建HR
        {
          path: "createHrInfo",
          name: "createHrInfo",
          component: () => import("../view/hrInfo/create.vue"),
        },
        //企业信息管理 企业信息列表
        {
          path: "enterpriseInfoList",
          name: "enterpriseInfoList",
          component: () => import("../view/enterpriseInfoManagement/index.vue"),
        },
        //企业信息管理 企业信息列表  创建企业信息
        {
          path: "createEnterpriseInfo",
          name: "createEnterpriseInfo",
          component: () =>
            import("../view/enterpriseInfoManagement/indexCreate.vue"),
        },
        //企业信息管理 签约管理
        {
          path: "signingManagement",
          name: "signingManagement",
          component: () =>
            import("../view/enterpriseInfoManagement/signContract.vue"),
        },
        //企业信息管理 签约管理  创建签约
        {
          path: "createSigningManagement",
          name: "createSigningManagement",
          component: () =>
            import("../view/enterpriseInfoManagement/signContractCreate.vue"),
        },
        // 企业信息管理 配置业务
        {
          path: "enterpriseBusiness",
          name: "enterpriseBusiness",
          component: () =>
            import("../view/enterpriseInfoManagement/business.vue"),
        },
        // 企业信息管理 配置业务  配置产品
        {
          path: "enterpriseProduct",
          name: "enterpriseProduct",
          component: () =>
            import("../view/enterpriseInfoManagement/product.vue"),
        },
        // 企业信息管理 配置政策
        {
          path: "enterprisePolicy",
          name: "enterprisePolicy",
          component: () =>
            import("../view/enterpriseInfoManagement/policy.vue"),
        },
        // 企业信息管理 配置政策  编辑或创建政策
        {
          path: "createEnterprisePolicy",
          name: "createEnterprisePolicy",
          component: () =>
            import("../view/enterpriseInfoManagement/editPolicy.vue"),
        },
        //员工信息管理 员工信息列表
        {
          path: "employeesInfoList",
          name: "employeesInfoList",
          component: () => import("../view/employeesInfoList/index.vue"),
        },
        //员工信息管理 员工信息列表 创建员工信息
        {
          path: "createEmployeesInfo",
          name: "createEmployeesInfo",
          component: () => import("../view/employeesInfoList/indexCreate.vue"),
        },
        //员工信息管理 员工签约列表
        {
          path: "employeesSigningList",
          name: "employeesSigningList",
          component: () => import("../view/employeesInfoList/sign.vue"),
        },
        //员工信息管理 员工签约列表 创建员工签约
        {
          path: "createEmployeesSigning",
          name: "createEmployeesSigning",
          component: () => import("../view/employeesInfoList/signCreate.vue"),
        },
        // 员工信息管理 员工产品服务花名册
        {
          path: "employeesRosterList",
          name: "employeesRosterList",
          component: () => import("../view/employeesInfoList/roster.vue"),
        },
        // 员工信息管理 员工产品服务花名册  创建员工产品服务花名册
        {
          path: "createEmployeesRoster",
          name: "createEmployeesRoster",
          component: () => import("../view/employeesInfoList/editRoster.vue"),
        },
        // 账户中心 企业账户列表
        {
          path: "enterpriseAccountList",
          name: "enterpriseAccountList",
          component: () => import("../view/accountCenter/ent.vue"),
        },
        // 账户中心 企业账户充值
        {
          path: "accountTopUp",
          name: "accountTopUp",
          component: () => import("../view/accountCenter/topUp.vue"),
        },
        // 账户中心 企业账户充值
        {
          path: "accountTopUpDetails",
          name: "accountTopUpDetails",
          component: () => import("../view/accountCenter/topUpDetails.vue"),
        },
        // 账户中心 机构账户列表
        {
          path: "officeAccountList",
          name: "officeAccountList",
          component: () => import("../view/accountCenter/org.vue"),
        },
        // 账户中心 hr账户列表
        {
          path: "hrAccountList",
          name: "hrAccountList",
          component: () => import("../view/accountCenter/hr.vue"),
        },
        // 账户中心 账户明细
        {
          path: "accountDetails",
          name: "accountDetails",
          component: () => import("../view/accountCenter/details.vue"),
        },
        // 账户中心 机构明细
        {
          path: "rmOfficeDetails",
          name: "rmOfficeDetails",
          component: () => import("../view/accountCenter/rmOfficeDetailed.vue"),
        },
        // 账户中心 hr明细
        {
          path: "hrDetails",
          name: "hrDetails",
          component: () => import("../view/accountCenter/hrDetailed.vue"),
        },
        // 账户中心 企业明细
        {
          path: "entDetails",
          name: "entDetails",
          component: () => import("../view/accountCenter/entDetailed.vue"),
        },
        // 业务中心 业务列表
        {
          path: "businessList",
          name: "businessList",
          component: () => import("../view/businessCenter/manage.vue"),
        },
        // 业务中心 业务产品管理
        {
          path: "productList",
          name: "productList",
          component: () => import("../view/businessCenter/product.vue"),
        },
        // 服务中心 工单管理
        {
          path: "workOrderList",
          name: "workOrderList",
          component: () => import("../view/serviceCenter/workOrder.vue"),
        },
        // 服务中心 工单管理  工单详情
        {
          path: "workOrderDetails",
          name: "workOrderDetails",
          component: () => import("../view/serviceCenter/workOrderDetails.vue"),
        },
        // 发票中心 发票订单
        {
          path: "invoiceOrder",
          name: "invoiceOrder",
          component: () => import("../view/invoiceCenter/invoiceOrder.vue"),
        },
        // 发票中心 发票订单  发票详情
        {
          path: "invoiceOrderDetails",
          name: "invoiceOrderDetails",
          component: () =>
            import("../view/invoiceCenter/invoiceOrderDetails.vue"),
        },
        // 发票中心 结算订单
        {
          path: "settlementOrder",
          name: "settlementOrder",
          component: () => import("../view/invoiceCenter/settlementOrder.vue"),
        },
        // 订单中心 灵工劳务报酬表
        {
          path: "laborRemuneration",
          name: "laborRemuneration",
          component: () =>
            import("../view/serviceCenter/laborRemuneration.vue"),
        },
        // 订单中心 灵工劳务报酬表  详情
        {
          path: "laborRemunerationDetails",
          name: "laborRemunerationDetails",
          component: () =>
            import("../view/serviceCenter/laborRemunerationDetail.vue"),
        },

        // 供应商管理 供应商列表
        {
          path: "supplierList",
          name: "supplierList",
          component: () => import("../view/supplier/supplierList.vue"),
        },
        // 添加供应商
        {
          path: "addSupplierList",
          name: "addSupplierList",
          component: () => import("../view/supplier/addSupplier.vue"),
        },

        // 客户管理 客户列表
        {
          path: "customerList",
          name: "customerList",
          component: () => import("../view/customer/customerList.vue"),
        },
        // 添加客户
        {
          path: "addCustomerList",
          name: "addCustomerList",
          component: () => import("../view/customer/addCustomer.vue"),
        },
        
        // 设备列表
        // {
        //   path: "deviceList",
        //   name: "deviceList",
        //   component: () => import("../view/device/deviceList.vue"),
        // },
        // 添加设备
        // {
        //   path: "addDevice",
        //   name: "addDevice",
        //   component: () => import("../view/device/addDevice.vue"),
        // },
        // 设备型号列表
        {
          path: "modelList",
          name: "modelList",
          component: () => import("../view/device/modelList.vue"),
        },
        // 添加设备信号
        {
          path: "addModel",
          name: "addModel",
          component: () => import("../view/device/addModel.vue"),
        },
        // 商品分类列表
        {
          path: "categoryList",
          name: "categoryList",
          component: () => import("../view/commodity/categoryList.vue"),
        },
        // 添加商品分类
        {
          path: "addCategory",
          name: "addCategory",
          component: () => import("../view/commodity/addCg.vue"),
        },
        // 商品列表
        {
          path: "commodityList",
          name: "commodityList",
          component: () => import("../view/commodity/commodityList.vue"),
        },
        // 添加商品
        {
          path: "addCommodity",
          name: "addCommodity",
          component: () => import("../view/commodity/addCommodity.vue"),
        },
        // 库存列表
        {
          path: "inventoryList",
          name: "inventoryList",
          component: () => import("../view/inventory/inventoryList.vue"),
        },
        // 设备入库
        {
          path: "inventory",
          name: "inventory",
          component: () => import("../view/inventory/inventory.vue"),
        },
        // 库存明细
        {
          path: "inventoryDetails",
          name: "inventoryDetails",
          component: () =>
            import("../view/inventoryDetails/inventoryDetails.vue"),
        },
        // 出库
        {
          path: "outbound",
          name: "outbound",
          component: () => import("../view/inventory/outbound.vue"),
        },
        // 出库详情
        {
          path: "outboundDetails",
          name: "outboundDetails",
          component: () => import("../view/inventory/outboundDetails.vue"),
        },
        // 品牌列表
        {
          path: "brandList",
          name: "brandList",
          component: () => import("../view/brand/brandList.vue"),
        },
        // 添加品牌
        {
          path: "addBrand",
          name: "addBrand",
          component: () => import("../view/brand/addBrand.vue"),
        },
        {
          path: "logistics",
          name: "logistics",
          component: () => import("../view/logistics/logisticsList.vue"),
        },
        {
          path: "outboundList",
          name: "outboundList",
          component: () => import("../view/outboundList/outboundList.vue"),
        },
        {
          path: "previwInfo",
          name: "previwInfo",
          component: () => import("../view/previwInfo/previwInfo.vue"),
        },
        {
          path: "addInfo",
          name: "addInfo",
          component: () => import("../view/previwInfo/addInfo.vue"),
        },
        {
          path: "orderList",
          name: "orderList",
          component: () => import("../view/orderStatus/orderStatus.vue"),
        }
      ],
    },
  ],
});

//全局路由守卫
router.beforeEach((to, from, next) => {
  /*路由发生变化修改页面title*/
  if (to.meta.title) {
    document.title = "管理系统";
    // 获取 JWT Token
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js